import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button, Typography } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { paySalairesToProfesseurs, getSalaireGroupById, fetchSalaires } from './salaire.reducer';
import { ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { getSortState } from 'react-jhipster';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';

export const SalairePaiementModal = (props: RouteComponentProps<{ salaireGroupId: string; ecoleid: string; anneeScolaireId: string }>) => {
  const salaireGroupId = props.match.params.salaireGroupId;
  const ecoleId = props.match.params.ecoleid;
  const anneeScolaireId = props.match.params.anneeScolaireId;
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );
  const dispatch = useAppDispatch();
  const loading = useAppSelector(state => state.salaire.loading);
  const salaireGroup = useAppSelector(state => state.salaire.salaireGroup);
  const selectedSalaires = useAppSelector(state => state.salaire.selectedSalaires);

  useEffect(() => {
    dispatch(getSalaireGroupById(salaireGroupId));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/salaires/${ecoleId}/${anneeScolaireId}/${salaireGroupId}/list`);
  };

  const confirmPay = event => {
    event.stopPropagation();
    const salaireGroupToPay = {
      ...salaireGroup,
      selectedSalaires,
    };
    dispatch(paySalairesToProfesseurs(salaireGroupToPay)).then(() => {
      dispatch(
        fetchSalaires({
          salaireGroupId,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          montant: 0,
          numeroSalaire: '',
        })
      );
    });
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      <Modal
        title="Confirmation de paiement des salaires"
        centered
        className="center"
        footer={[
          <Button key="back" onClick={goBack} style={{ backgroundColor: 'blue', color: 'white' }}>
            Annuler
          </Button>,
          <Button key="submit" loading={loading} style={{ backgroundColor: 'green', color: 'white' }} onClick={confirmPay}>
            Payer
          </Button>,
        ]}
        visible={true}
        closable={false}
      >
        <p className="center">
          <WarningOutlined style={{ color: 'red', fontSize: '24px', marginRight: '10px' }} />
          Vous etes sur le point de déclencher le paiement de{' '}
          <strong style={{ color: 'black', fontSize: '16px' }}>{selectedSalaires.length} salaires </strong> du mois de{' '}
          {`${salaireGroup.mois} ${salaireGroup.annee}`} ?. Cette action n&apos;est pas reversible. <br />
          Etes-vous certain d&apos;avoir fait toutes les vérifications nécessaires avant de poursuivre ?{' '}
        </p>
      </Modal>
    </>
  );
};

export default SalairePaiementModal;
